import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CountriesPhoneHelperService } from './phone-lib/countries-phone-helper.service';

@NgModule({
  imports: [CommonModule],
  providers: [CountriesPhoneHelperService],
})
export class UtilModule {}
export * from './phone-lib/countries-phone-helper.service';
export * from './phone-lib/country-phone-code-model';
